// extracted by mini-css-extract-plugin
export default {"classesWrapper":"ClassesWrapper_classesWrapper__gJrEB","addClass":"ClassesWrapper_addClass__R4jyg"};